import React, { Component } from 'react';
import { BrowserRouter, Route } from "react-router-dom";
import $ from "jquery";
import {Header} from './header';
import {Footer} from './footer';
import {Home} from './page/home';
import {About} from './page/about';
import {Contact} from './page/contact';
import './assets/scss/style.scss';

class App extends Component {
  render() {
    return (
      <BrowserRouter>
        <div className="App">
          <Header></Header>
          <Route path="/" exact component={Home} />
          <Route path="/about" component={About} />
          <Route path="/contact" component={Contact} />
          <Footer></Footer>
        </div>
      </BrowserRouter>
    );
  }
  componentDidMount = () => {
    $("#header a").click(function(){
        console.log("Menüye tıklandı :)");
    });
  }
}

export default App;